
// (async function () {


//     async function onCartUpdate() {
//         try {
//             const res = await fetch("/cart.js", {
//                 headers: { Accept: "application/json" }
//             });

//             const cart = await res.json();
//             console.log("vs_cart", cart);
//             let product_id = cart.items.forEach(element => {
    
//                        console.log("vsss",element.product_id);
                
//             });
     


//         } catch (err) {
//             console.error("Cart update failed:", err);
//         }
//     }

//     const triggerCartUpdate = () => onCartUpdate();

//     onCartUpdate();

//     document.addEventListener("cart:updated", triggerCartUpdate);

//     if (!window.__shippingBarPatched) {
//         window.__shippingBarPatched = true;

//         const originalFetch = window.fetch;

//         window.fetch = async (...args) => {
//             const response = await originalFetch(...args);

//             try {
//                 const url = typeof args[0] === "string"
//                     ? args[0]
//                     : args[0]?.url || "";

//                 if (/\/cart\/(add|change|update)/.test(url)) {
//                     triggerCartUpdate();
//                 }
//             } catch (e) { }

//             return response;
//         };

//         const originalOpen = XMLHttpRequest.prototype.open;

//         XMLHttpRequest.prototype.open = function (...args) {
//             this.addEventListener("load", () => {
//                 const url = typeof args[1] === "string" ? args[1] : "";

//                 if (/\/cart\/(add|change|update)/.test(url)) {
//                     triggerCartUpdate();
//                 }
//             });

//             return originalOpen.apply(this, args);
//         };
//     }
// })();


// VS_SCRIPT

(function () {
    let previousCart = null;
    let updateQueue = Promise.resolve();

    function openCartDrawer() {
        setTimeout(() => {
            if (window.CartDrawerPremium?.open) {
                window.CartDrawerPremium.open();
            }
        }, 800);
    }

    function getPieceType(item) {
        const option = item.variant_options?.[0]
            || item.options_with_values?.[0]?.value
            || "";

        return /^(shirt|bottom)$/i.test(String(option).trim())
            ? String(option).trim().toLowerCase()
            : null;
    }

    function getPairs(cart) {
        return cart.items.reduce((pairs, item) => {
            const pieceType = getPieceType(item);
            if (!pieceType) return pairs;

            const pair = pairs.get(item.product_id) || {};
            pair[pieceType] = item;
            pairs.set(item.product_id, pair);
            return pairs;
        }, new Map());
    }

    async function getCart() {
        const response = await fetch("/cart.js", {
            headers: { Accept: "application/json" }
        });

        if (!response.ok) throw new Error(`Unable to read cart (${response.status})`);
        return response.json();
    }

    function changesForPairs(cart, priorCart) {
        // Do not alter an existing cart on the first page load. From then on, use the
        // changed piece as the source of truth and apply its quantity to its partner.
        if (!priorCart) return {};

        const updates = {};
        const currentPairs = getPairs(cart);
        const previousPairs = getPairs(priorCart);

        currentPairs.forEach((current, productId) => {
            const previous = previousPairs.get(productId);

            if (current.shirt && current.bottom) {
                if (current.shirt.quantity === current.bottom.quantity) return;

                const shirtChanged = previous?.shirt
                    && current.shirt.quantity !== previous.shirt.quantity;
                const bottomChanged = previous?.bottom
                    && current.bottom.quantity !== previous.bottom.quantity;
                if (shirtChanged || !bottomChanged) {
                    updates[current.bottom.key] = current.shirt.quantity;
                } else {
                    updates[current.shirt.key] = current.bottom.quantity;
                }
                return;
            }

            if (previous?.shirt && previous?.bottom) {
                const remainingItem = current.shirt || current.bottom;
                if (remainingItem) updates[remainingItem.key] = 0;
            }
        });

        return updates;
    }

    async function syncCartPairs() {
        try {
            const cart = await getCart();

            console.log("vs_test", cart)

            if (cart.items.some(item => item.discounts?.some(discount => discount.title === "CORD15%"))) {
            document.querySelector(".discount-progress-wrap")?.style.setProperty("display", "none", "important");
            }

            // vs_02: fine collection product get product tag and hide the progressbar from my cart drawer
            
            
            const requiredTag = '80s Collection';
            let hasTaggedProduct = false;
            
           for (const item of cart.items) {
                    const handle = item.handle;

                    const productResponse = await fetch(`/products/${handle}.js`);
                    const product = await productResponse.json();

                    if (product.tags.includes(requiredTag)) {
                        hasTaggedProduct = true;
                        break;
                    }
          }

            if(hasTaggedProduct){
                document.querySelector(".discount-progress-wrap")?.style.setProperty("display", "none", "important");
                console.log("final- removed-vs")
            }
            





            const updates = changesForPairs(cart, previousCart);
            previousCart = cart;

            if (!Object.keys(updates).length) return;

            const response = await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({ updates })
            });

            if (!response.ok) throw new Error(`Unable to sync co-ord pair (${response.status})`);

            previousCart = await response.json();
            document.dispatchEvent(new CustomEvent("cart:updated"));
            openCartDrawer();
        } catch (error) {
            console.error("Co-ord cart synchronisation failed:", error);
        }
    }

    function queueCartSync() {
        updateQueue = updateQueue.then(syncCartPairs, syncCartPairs);
        return updateQueue;
    }

    queueCartSync();
    document.addEventListener("cart:updated", queueCartSync);

    if (!window.__hamptonsCoordCartPatched) {
        window.__hamptonsCoordCartPatched = true;

        const originalFetch = window.fetch;
        window.fetch = async (...args) => {
            const response = await originalFetch(...args);
            const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

            if (/\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(url)) {
                queueCartSync();
            }
            return response;
        };

        const originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (...args) {
            this.addEventListener("load", () => {
                const url = typeof args[1] === "string" ? args[1] : "";
                if (/\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(url)) {
                    queueCartSync();
                }
            });
            return originalOpen.apply(this, args);
        };
    }
})();
